export default{
  cities: (state) => state.cities
}



// WEBPACK FOOTER //
// ./src/components/city/store/getters.js